import { toRaw } from 'vue';

export default defineNuxtPlugin((nuxtApp) => {
  const assetFilter = {
    filterImages: (assets) => {
      return assets.filter(asset => {
        return asset.resource_type == 'images'
      });
    },
    firstVideoAsset: (assets) => {
      let videos = assets.filter(asset => {
        return asset.resource_type == 'videos'
      });
      if (videos.length == 0) {
        return null;
      }
      return toRaw(videos[0]);
    },
    firstDigitalTwinAsset: (assets) => {
      let digitalTwins = assets.filter(asset => {
        return asset.resource_type == 'digital-twins'
      });
      if (digitalTwins.length == 0) {
        return null;
      }
      return toRaw(digitalTwins[0]);
    },
    firstStreetViewAsset: (assets) => {
      let viewpoints = assets.filter(asset => {
        return asset.resource_type == 'viewpoints' && typeof asset.resource.label === 'string' &&  (asset.resource.label.includes('Facade') || asset.resource.label.includes('Fachada'));
      });
      if (viewpoints.length == 0) {
        return null;
      }
      return toRaw(viewpoints[0]);
    },
    findAsset: (assets, assetId) => {
      return assets.find(asset => {
        if (!asset.resource) {
          console.error('Missing asset resource');
        }
        if (asset.resource.guid) {
          return asset.resource.guid == assetId;
        }
        if (asset.resource.id) {
          return asset.resource.id == assetId;
        }
      });
    },
    orderByResourceName: (payload) => {
      // Define the desired order of resource names
      const order = ['living-room', 'bedroom', 'kitchen', 'dining-room', 'bathroom'];

      // Sort the array based on the resource name order
      return payload.sort((a, b) => {
        const nameA = a.resource.name;
        const nameB = b.resource.name;

        // Get the index of each name in the order array
        const indexA = order.indexOf(nameA);
        const indexB = order.indexOf(nameB);

        // If the name is not in the order array, treat it as having the lowest priority
        const adjustedIndexA = indexA === -1 ? order.length : indexA;
        const adjustedIndexB = indexB === -1 ? order.length : indexB;

        // Compare the adjusted indices
        return adjustedIndexA - adjustedIndexB;
      });
    },
    orderResourcesByUniqueTypes: (payload) => {
      // Define the desired order of resource names
      const order = ['living-room', 'bedroom', 'kitchen', 'dining-room', 'bathroom'];

      // Create an array to hold the selected unique rooms
      const selected = [];
      // Create an array to hold the remaining rooms
      const remaining = [...payload];

      // First pass: Select one of each room type in the correct order
      for (const roomType of order) {
        const index = remaining.findIndex(item => item.resource.name === roomType);
        if (index !== -1) {
          // Add the first occurrence of this room type to 'selected'
          selected.push(remaining[index]);
          // Remove the selected room from 'remaining'
          remaining.splice(index, 1);
        }
      }

      // Second pass: Append the remaining rooms after the selected ones
      return [...selected, ...remaining];
    },
    filterByParentType: (assets, parentType) => {
      return assets.filter(asset => {
        // Filter out undefined or null assets
        if (!asset) return false;
        return asset.parent_type == parentType
      });
    },
    // Iframe asset must include `thumbnailUrl` and `src`
    transformIframeAssets: (assets) => {
      return assets.map(asset => {
        return asset
      });
    }
  };
  nuxtApp.provide('assetFilter', assetFilter);
});
